<template>
<div v-if="team && roster">
    <messageModal v-if="showMessage" message="La star a été renvoyée comme une merde"></messageModal>
    <confirmModal v-if="showFireStarConfirmModal"
                  message="Vous êtes sûr de vouloir renvoyer la star ? ça vous évitera de payer son salaire."
                  @confirm="confirmRevokeStar"
                  @closeMessage="showFireStarConfirmModal = false"></confirmModal>
    <div v-else-if="team.rostered_star_player === null" class="row columns">
        <div class="large-12 inner-title">
            Engager un champion sur le long terme :
        </div>
        <div class="large-12 inner-subtitle">
            Vous devrez payer la valeur du champion, puis un salaire après chaque match.
            Adressez vous à votre commissaire de ligue pour plus de précisions
        </div>
        <table>
            <thead>
                <tr class="">
                    <th width="200">Nom</th>
                    <th width="5">M</th>
                    <th width="5">F</th>
                    <th width="5">Ag</th>
                    <th width="5">Ar</th>
                    <th width="400">Compétences</th>
                    <th with="25">coût</th>
                    <th width="125"></th>
                    <th width="50"></th>
                </tr>
            </thead>
            <tbody class="roster" v-if="roster">
                <tr v-if="buyableStarPlayer.length > 0">
                    <td class="action">
                      <select v-model="selectedStarPlayer" class="starbox">
                        <option v-for="star of buyableStarPlayer" v-bind:value="star">
                          {{ star.name }}
                        </option>
                      </select>
                    </td>
                    <td v-if="selectedStarPlayer">{{selectedStarPlayer.M}}</td>
                    <td v-else colspan="6">selectionnez une star</td>
                    <td v-if="selectedStarPlayer">{{selectedStarPlayer.F}}</td>
                    <td v-if="selectedStarPlayer">{{selectedStarPlayer.Ag}}</td>
                    <td v-if="selectedStarPlayer">{{selectedStarPlayer.Ar}}</td>
                    <td v-if="selectedStarPlayer">
                        <span v-for="skill of selectedStarPlayer.skills" >
                            {{skill.name}},
                        </span>
                    </td>
                    <td v-if="selectedStarPlayer">{{selectedStarPlayer.cost}} 000</td>
                    <td colspan="2" v-if="!selectedStarPlayer && !chosenStarPlayer" class="action"></td>
                    <td colspan="2" v-if="selectedStarPlayer && !chosenStarPlayer" class="action">
                        <button v-bind:class="{ deactivated: currentTreasury <  selectedStarPlayer.cost, action:true }"
                                :disabled="currentTreasury <  selectedStarPlayer.cost"
                                @click="addStarPlayer()">Ajouter au panier</button>
                    </td>
                    <td colspan="2" v-if="chosenStarPlayer" class="action">
                      <button v-bind:class="{ deactivated: chosenStarPlayer === null, action:true, alert:true }"
                                @click="removeStarPlayer()">Retirer du panier</button>
                    </td>
                </tr>
                <tr v-else>
                  <td colspan="8">
                    <div> Navré vous n'avez pas les moyens d'engager une star. La prochaine fois peut être</div>
                  </td>
                </tr>

                <tr>
                    <td colspan="6" class="sous-total right">Budget Star Player</td>
                    <td class="sous-total">{{starCost}} 000</td>
                    <td colspan="2"></td>
                </tr>
            </tbody>
        </table>
    </div>
    <div v-if="team.rostered_star_player" class="row columns">
        <div class="large-12 inner-title">
            Champion
        </div>
        <div class="large-12 inner-subtitle">
            Vous avez déjà engagé <strong>{{team.rostered_star_player.ref_star_player.name}}.</strong>
            Maintenant, il faut payer son salaire.
        </div>
        <div class="large-12 inner-subtitle">
          Si vous n'avez pas les moyens, ou si vous n'en voulez plus, il faut clicker sur "renvoyer la star". Et lui dire au revoir.
        </div>
        <table>
            <thead>
                <tr class="">
                    <th width="20%">Nom</th>
                    <th width="40%">Salaire</th>
                    <th width="20%"></th>
                    <th width="20%"></th>
                </tr>
            </thead>
            <tbody class="roster" v-if="roster">
                <tr>
                    <td class="action">
                      {{team.rostered_star_player.ref_star_player.name}}
                    </td>
                    <td>{{starCost}} 000</td>
                    <td class="action">
                        <button class="deactivated action" disabled>Paiment obligatoire</button>
                    </td>
                    <td>
                      <button v-bind:class="{ action:true, alert:true }"
                                v-on:click="revokeStar()" >Renvoyer la star</button>
                    </td>
                </tr>

                <tr>
                    <td class="sous-total right">Budget Star Player</td>
                    <td class="sous-total">{{starCost}} 000</td>
                    <td colspan="2"></td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import spinner from '../../common/spinner.vue'
import teamPurchases from '../../../api/team-purchases.api'
import messageModal from '../../common/message-modal.vue'
import confirmModal from '../../common/confirm-modal.vue'

export default {
  name: 'starPlayerPurchase',
  components: {
    spinner,
    messageModal,
    confirmModal
  },
  props: {
    'roster': {},
    'team': {},
    'currentTreasury': 0
  },
  data () {
    return {
      // la liste des joueurs actuellement présents dans l'équipe, et de ceux que l'on achète
      selectedStarPlayer: null,
      chosenStarPlayer: null,
      starCost: 0,
      showFireStarConfirmModal: false,
      showMessage: false
    }
  },
  computed: {
    buyableStarPlayer: function () {
      let buyableStarPlayer = []
      if (this.roster) {
        this.roster.star_players.forEach(star => {
          if (star.cost <= this.currentTreasury) {
            buyableStarPlayer.push(star)
          }
        })
      }
      return buyableStarPlayer
    }
  },
  mounted () {
    if (this.team.rostered_star_player) {
      this.starCost = this.team.rostered_star_player.salary
      this.$emit('updateStarCost')
    }
    return 0
  },
  methods: {
    addStarPlayer: function (val) {
      this.chosenStarPlayer = this.selectedStarPlayer
      this.starCost = this.selectedStarPlayer.cost
      this.$emit('updateStarCost')
    },
    removeStarPlayer: function (val) {
      this.chosenStarPlayer = null
      this.starCost = 0
      this.$emit('updateStarCost')
    },
    revokeStar () {
      this.showFireStarConfirmModal = true
    },
    purchaseNewStar () {
      if (this.chosenStarPlayer !== null && this.team.rostered_star_player === null) {
        return true
      }
      return false
    },
    paySalary () {
      if (this.chosenStarPlayer === null && this.team.rostered_star_player !== null) {
        return true
      }
      return false
    },
    getDatas () {
      let starDatas = null
      if (this.chosenStarPlayer !== null) {
        starDatas = {}
        starDatas.star_player = {}
        starDatas.star_player.num = 0
        starDatas.star_player.ref_star_player = this.chosenStarPlayer.id
      } else if (this.team.rostered_star_player) {
        starDatas.star_player_salary = 'pay'
      }
      return starDatas
    },
    confirmRevokeStar () {
      let purchases = {}
      purchases.revoke = {}
      purchases.revoke.star_player_salary = 'revoke'
      var id = this.team.id
      teamPurchases.api.publishTeamPurchases(this.team.id, purchases)
      .then(response => {
        this.$store.dispatch('purgeDetailedTeam')
        this.$store.dispatch('getDetailedTeam', id)
        this.showMessage = true
      },
      error => {
        console.log('erreur impossible to publish purchases')
        console.log(error)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}

.starbox {
  margin-bottom: 0;
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: left;
  font-size: 1rem;
  font-weight: 400;
}

.inner-subtitle{
  text-align: left;
  font-size: 0.8rem;
  font-weight: 300;
  margin-bottom: 0.3rem
}
</style>



// WEBPACK FOOTER //
// star-purchase.vue?4137469a